/**
 * Notifications API Service
 *
 * API calls for user and admin notifications.
 * Uses apiClient for CSRF token support on PATCH/POST/DELETE requests.
 */

import { apiClient } from "./apiClient";

export interface NotificationResponse {
  id: string;
  user_id?: string;
  type: string;
  title: string;
  message: string;
  severity: string;
  category?: string | null;
  context?: Record<string, unknown> | null;
  created_at: string;
  read_at?: string | null;
}

export interface NotificationsListResponse {
  notifications: NotificationResponse[];
  unread_count: number;
  total: number;
}

/**
 * List user notifications
 *
 * Returns only notifications for the current authenticated user.
 * Each user sees only their own notifications.
 */
export async function listUserNotifications(): Promise<NotificationResponse[]> {
  const response = await apiClient.get<NotificationsListResponse>(
    "/user/notifications",
  );
  return response.data.notifications ?? [];
}

/**
 * Mark notification as read
 */
export async function markNotificationAsRead(
  notificationId: string,
): Promise<void> {
  await apiClient.patch(`/user/notifications/${notificationId}/read`);
}

/**
 * List admin notifications
 */
export async function listAdminNotifications(): Promise<NotificationResponse[]> {
  const response = await apiClient.get<NotificationResponse[]>(
    "/admin/notifications",
  );
  return response.data;
}

